
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info-acquisti-online",
      function () {
        return require("private-next-pages/info-acquisti-online/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info-acquisti-online"])
      });
    }
  